const supportedLanguages = [
  { name: 'English', code: 'en-CA' },
  { name: 'Français', code: 'fr-CA' }
];

module.exports = {
  supportedLanguages
};


// WEBPACK FOOTER //
// ./src/copy/localization.js